module.exports = __webpack_public_path__ + "img/YER.c84ee56a.svg";